import { Component, HostBinding, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'eui-card-media',
    templateUrl: './eui-card-media.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardMediaComponent {
    @Input() imageUrl: string;
    @Input() imageLegend: string;
    @Input() imageClickUrl: string;
    @Input() imageClickUrlExternal: string;
    @Input() imageDescription = 'eUI Card Image';

    @HostBinding('class') string = 'eui-card-media';

    constructor( ) {
    }
}
